import { useEffect, useState } from "react";
import { ratingList } from "../../api/HttpApis";

const useCommonRating = () => {
    const [ratingData, setRatingData] = useState();

    useEffect(() => {
        const getRatingList = async () => {         
                const ratingResponse = await ratingList();
                setRatingData(ratingResponse?.data?.data);
            }
        getRatingList()
    }, [])
 const ratingOptions = ratingData;
 const accessOptions = [
        { id: 1, name: "Free" },
        { id: 2, name: "Paid" },
    ];
    return {
      ratingOptions,
      accessOptions,
    };
}
export default useCommonRating;